import React, { useEffect, useState } from "react";
import API, { CONFIG, UPDATE_CONFIG } from "../../network/api";
import { TEXT_DEF } from "../../constant/text";
import { Button } from "antd";
import ModalCommon from "../../components/Modal";
import TextArea from "antd/lib/input/TextArea";

const TEXT = {
    rules: "Luật chơi",
    terms: "Thể lệ ",
}

const SetupRule = () => {
    const [configGame, setConfigGame] = useState();
    const [isShowModalConfirm, setIsShowModalConfirm] = useState(false);
    const [isShowModalSuccess, setIsShowModalSuccess] = useState(false);

    const [rules, setRules] = useState();
    const [term1, setTerm1] = useState();
    const [term2, setTerm2] = useState();
    const [term3, setTerm3] = useState();
    const [term4, setTerm4] = useState();

    useEffect(() => {
        getDataConfig();
    }, []);

    const getDataConfig = async () => {
        try {
            const res = await API.get(`${CONFIG}`);
            const data = res.data.data;
            setConfigGame({
                rules: data?.rules,
                term1: data?.term1,
                term2: data?.term2,
                term3: data?.term3,
                term4: data?.term4
            });
        } catch (err) {
            console.log(err);
        }
    };

    const handleChangeInput = (e, key) => {
        switch (key) {
            case 1: setRules(e?.target.value || ""); return;
            case 2: setTerm1(e?.target.value || ""); return;
            case 3: setTerm2(e?.target.value || ""); return;
            case 4: setTerm3(e?.target.value || ""); return;
            case 5: setTerm4(e?.target.value || ""); return;
        }
    };

    const handleUpdateConfig = async () => {
        try {
            setIsShowModalConfirm(false);
            setIsShowModalSuccess(true);
            const body = {
                config: {
                    rules: rules !== undefined ? rules : configGame?.rules,
                    term1: term1 !== undefined ? term1 : configGame?.term1,
                    term2: term2 !== undefined ? term2 : configGame?.term2,
                    term3: term3 !== undefined ? term3 : configGame?.term3,
                    term4: term4 !== undefined ? term4 : configGame?.term4,
                }
            };
            
            await API.patch(`${UPDATE_CONFIG}`, body);
        } catch (err) {
            console.log(err);
        }
    };

    const handleShowModal = () => {
        setIsShowModalConfirm(true);
    };

    const renderInput = (key, defaultValue, changeInput, rows, label) => {
        return (
            <div className={`flex w-full items-center ${key !== "vip0_5" ? "mt-4" : ""}`}>
                <div className="flex w-[20%] justify-end mr-10">{label}:</div>
                <div className="w-[60%]">
                    <TextArea 
                        key={key} 
                        style={{ width: "100%" }}
                        onChange={changeInput} 
                        rows={rows} 
                        defaultValue={defaultValue} 
                    />
                </div>
            </div>
        )
    }

    return (
        <div className="col-12">
            {configGame && 
                <div className="col-12">
                    <div className="flex w-full">
                        <div className="flex flex-col w-full items-center justify-center">
                            <div className="col-10 mt-2 flex flex-col items-center justify-center">
                                {configGame && renderInput(
                                    "rules",
                                    configGame?.rules, 
                                    (e) => handleChangeInput(e, 1), 
                                    10, `${TEXT.rules}`
                                )}

                                {renderInput(
                                    "terms",
                                    configGame?.term1, 
                                    (e) => handleChangeInput(e, 2), 
                                    10, `${TEXT.terms}1`
                                )}

                                {renderInput(
                                    "terms",
                                    configGame?.term2, 
                                    (e) => handleChangeInput(e, 3), 
                                    10, `${TEXT.terms}2`
                                )}
                                {renderInput(
                                    "terms",
                                    configGame?.term3, 
                                    (e) => handleChangeInput(e, 4), 
                                    10, `${TEXT.terms}3`
                                )}
                                {renderInput(
                                    "terms",
                                    configGame?.term4, 
                                    (e) => handleChangeInput(e, 5), 
                                    10, `${TEXT.terms}4`
                                )}
                            </div>
                            <div className="col-10 mt-5 flex items-center justify-center">
                                <Button type="primary" onClick={handleShowModal}>
                                    Cập nhật
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            }
            {isShowModalConfirm && (
                <ModalCommon
                    isShow={isShowModalConfirm}
                    message={TEXT_DEF.text0062}
                    txtBtnAcc={TEXT_DEF.text0008}
                    textBtnClose={TEXT_DEF.text0023}
                    actionNext={handleUpdateConfig}
                    close={() => setIsShowModalConfirm(false)}
                />
            )}
            {isShowModalSuccess && (
                <ModalCommon
                    isShow={isShowModalSuccess}
                    message={TEXT_DEF.text0063}
                    txtBtnAcc={TEXT_DEF.text0007}
                    actionNext={() => {
                        setIsShowModalSuccess(false);
                    }}
                    close={() => {
                        setIsShowModalSuccess(false);
                    }}
                />
            )}
        </div>
    );
};

export default SetupRule;
